import { useParams } from "react-router-dom"
import { getIndustryDetail } from "./api/apiCalls"
import { useQuery } from "@tanstack/react-query"
import Loading from "../../components/common/Loading"
import ProjectGridSection from "../../components/common/ProjectGridSection"
import BaseSecondaryHero from "../../components/layout/BaseSecondaryHero"
import ComparisonSection from "./components/ComparisonSection"
import IndustryServices from "./components/IndustryServices"
import OperatingSection from "../../components/common/OperatingSection"
import BaseHeadline from "../../components/general/BaseHeadline"
import ContactCTA from "../../components/common/ContactCTA"
import ClientReviews from "./components/ClientReviews"
import Functionality from "./components/Functionality"

export default function IndustryDetailPage() {
    const { id } = useParams()

    const { data: industryDetail, isLoading: industryDetailLoading } = useQuery({
        queryKey: ["industryDetail", id],
        queryFn: () => getIndustryDetail(id ?? ""),
    })

    if (industryDetailLoading || !industryDetail) {
        return <Loading />
    }

    const dataFaq = industryDetail.faq.map((item, index) => ({
        attributes: {
            number: Number("0" + item.number) || Number("0" + (index + 1)),
            headline: item.headline,
            description: item.text,
        },
    }))

    return (
        <>
            <BaseSecondaryHero
                heading={industryDetail.hero}
                image={industryDetail.optionalIndividualHeroBg?.data?.attributes.url}
            />
            <ComparisonSection
                softwareComparisonTransparent={industryDetail.comparisonTransparent}
                leftSide={industryDetail.leftSide}
                rightSide={industryDetail.rightSide}
            />
            <ProjectGridSection
                className="max-w-[1500px]"
                heading={industryDetail.projectsHeading}
                projects={industryDetail.projects.data.flatMap((project) => {
                    const source = project.attributes.preview ?? project.attributes

                    if (!source.label || !source.sublabel || !source.positionClass) {
                        return []
                    }

                    return [
                        {
                            id: project.id,
                            label: source.label,
                            sublabel: source.sublabel,
                            positionClass: source.positionClass,
                            alignmentClass: source.alignmentClass,
                            width: source.width,
                            quote: source.quote,
                            url: source.url,
                            previewImage: project.attributes.previewImage,
                            screenshot: project.attributes.screenshot ?? source.screenshot,
                            hasDetailPage: project.attributes.hasDetailPage ?? source.hasDetailPage ?? false,
                        },
                    ]
                })}
            />
            <IndustryServices heading={industryDetail.servicesHeading} slides={industryDetail.services} />

            {industryDetail.functionsHeading && industryDetail.functionsSubheading && industryDetail.functionsSubheading2 
            && industryDetail.functionCard && (
            <Functionality 
            heading={industryDetail.functionsHeading}
            subheading={industryDetail.functionsSubheading}
            subheading2={industryDetail.functionsSubheading2}
            functionCard={industryDetail.functionCard}
            />
            )}

            {industryDetail.clientReviewsHeading && (
                <ClientReviews 
                heading={industryDetail.clientReviewsHeading} 
                projectFeedbacks={industryDetail.projectFeedbacks}/>
            )}

            <section className="py-20 px-4 w-full sm:px-8 xl:px-0">
                <div className="max-w-page mx-auto">
                    <BaseHeadline
                        label={industryDetail.faqHeading.label}
                        headline={industryDetail.faqHeading.headline}
                        text={industryDetail.faqHeading.text}
                        center
                    />

                    <OperatingSection data={dataFaq} />
                </div>
            </section>
            <ContactCTA />
        </>
    )
}
